import React, {Component} from "react";

class Header extends Component {
    render() {
        return(
            <div className='header'>
                <h1>Star Wars</h1>
            </div>
        )
    }
} 

export default Header;